import styles from "../styles/GetAppLanding.module.scss";
import inc42Logo from "../assets/press-inc42.svg";
import readReportArrow from "../assets/press-read-report-arrow.svg";
import techCrunchLogo from "../assets/press-techcrunch.svg";
import toiLogo from "../assets/press-toi.png";

const pressItems = [
  {
    copy: "Covered Abound's $14M raise to help more Indian Americans send money home.",
    logo: techCrunchLogo,
    alt: "TechCrunch",
    url: "https://techcrunch.com/2025/03/27/times-internet-spin-out-abound-raises-14m-to-let-more-indian-americans-send-money-home/",
  },
  {
    copy: "Reported Abound's seed funding led by NEAR Foundation to expand product and tech.",
    logo: inc42Logo,
    alt: "Inc42",
    url: "https://inc42.com/buzz/cross-border-financial-solutions-platform-abound-bags-14-mn/",
  },
  {
    copy: "Covered Abound's AI Financial Autopilot for NRIs in partnership with NEAR AI.",
    logo: toiLogo,
    alt: "The Times of India",
    url: "https://timesofindia.indiatimes.com/business/india-business/abound-launches-ai-financial-autopilot-for-nris-in-partnership-with-near-ai/articleshow/130090515.cms",
  },
];

const PressSection = () => {
  return (
    <section className={styles.pressSection} id="company">
      <div className={styles.pressInner}>
        <h2>Recognized by leading fintech and business publications</h2>
        <div className={styles.pressGrid}>
          {pressItems.map((item) => (
            <article key={item.alt}>
              <p>{item.copy}</p>
              <a
                className={styles.readReportLink}
                href={item.url}
                target="_blank"
              >
                <span>Read report</span>
                <img src={readReportArrow} alt="" aria-hidden="true" />
              </a>
              <img src={item.logo} alt={item.alt} />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PressSection;
